var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvailabilityIcon = function SvgAvailabilityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#availability_icon_svg__a)",
    d: "M10 34h10.5v3H10zm0-10.5h13.5v3H10zM10 13h30v3H10zm28.011 13.538 1.734-.587 1.5 2.598-1.374 1.207c.173.82.173 1.668 0 2.487l1.374 1.208-1.5 2.598-1.734-.587a6 6 0 0 1-2.153 1.245L35.5 38.5h-3l-.36-1.794a6 6 0 0 1-2.151-1.245l-1.734.588-1.5-2.598 1.374-1.208a6 6 0 0 1 0-2.487l-1.374-1.207 1.5-2.598 1.734.587a6 6 0 0 1 2.153-1.245L32.5 23.5h3l.36 1.794c.804.261 1.536.69 2.151 1.245zM34 34a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "availability_icon_svg__a",
    x1: 10,
    x2: 41.245,
    y1: 25.75,
    y2: 25.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D52F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  })))));
};
export default SvgAvailabilityIcon;